export default __webpack_public_path__ + "static/media/img_three.e8c37b91.png";